import React from 'react';

interface Props {
  fillColor?: string;
}
function MaleIcon({ fillColor = '#17385D' }: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="16"
      viewBox="0 0 14 16"
      fill="none">
      <path
        d="M9.75 1C9.33438 1 9 1.33437 9 1.75C9 2.16562 9.33438 2.5 9.75 2.5H11.4406L8.825 5.11562C7.9 4.41562 6.74687 4 5.5 4C2.4625 4 0 6.4625 0 9.5C0 12.5375 2.4625 15 5.5 15C8.5375 15 11 12.5375 11 9.5C11 8.25313 10.5844 7.1 9.88437 6.17812L12.5 3.55938V5.25C12.5 5.66563 12.8344 6 13.25 6C13.6656 6 14 5.66563 14 5.25V1.75C14 1.33437 13.6656 1 13.25 1H9.75ZM1.5 9.5C1.5 8.43913 1.92143 7.42172 2.67157 6.67157C3.42172 5.92143 4.43913 5.5 5.5 5.5C6.56087 5.5 7.57828 5.92143 8.32843 6.67157C9.07857 7.42172 9.5 8.43913 9.5 9.5C9.5 10.5609 9.07857 11.5783 8.32843 12.3284C7.57828 13.0786 6.56087 13.5 5.5 13.5C4.43913 13.5 3.42172 13.0786 2.67157 12.3284C1.92143 11.5783 1.5 10.5609 1.5 9.5Z"
        fill={fillColor}
      />
    </svg>
  );
}

export default MaleIcon;
